import GuideLayout from './GuideLayout';

export default function GuideEventi() {
  return (
    <GuideLayout
      slug="eventi-affitti-brevi"
      title="Eventi locali e affitti brevi: il calendario 2026/2027 per host"
      breadcrumbLabel="Eventi e affitti brevi"
      description="I mega-eventi italiani 2026/2027 che spostano migliaia di prenotazioni e fanno schizzare i prezzi degli affitti brevi: Sanremo, America's Cup Napoli, Salone del Mobile Milano, Vasco Rossi tour stadi, F1 Imola e Monza, MotoGP Mugello. Con percentuali di rincaro tipiche per zona."
      readingTime={10}
      faqs={faqs}
      howTo={howTo}
    >
      <h2>Perché gli eventi sono la leva di pricing più potente</h2>
      <p>
        Un evento di rilevanza nazionale o internazionale, nel raggio di 30 km dalla tua struttura, è capace di <strong>moltiplicare per 2-5x</strong> la domanda di alloggio. La <strong>curva di prenotazione anticipata</strong> arriva tipicamente a <strong>180 giorni</strong>: i fan/professionisti più organizzati prenotano subito dopo l'annuncio ufficiale.
      </p>
      <p>
        Se non aggiorni i prezzi <strong>prima</strong> che escano gli early bird, lasci sul tavolo migliaia di euro. Se invece sali troppo presto, rischi di perdere le prenotazioni base che sostengono il calendario quando l'evento ancora è "in dubbio".
      </p>
      <p>
        La regola d'oro: <strong>aggiorna i prezzi dei periodi evento appena conosci la data ufficiale</strong>. Locazione Turistica integra <strong>419 eventi italiani 2026/2027</strong> con alert automatici a 90, 60 e 30 giorni prima per ricordarti di intervenire.
      </p>

      <h2>Mega-eventi 2026/2027 — calendario completo</h2>

      <h3>Eventi musicali (concerti, tour stadi e festival)</h3>
      <table>
        <thead>
          <tr><th>Evento</th><th>Quando</th><th>Dove</th><th>Rincaro tipico</th></tr>
        </thead>
        <tbody>
          <tr><td>Festival di Sanremo 2027</td><td>9-13 feb 2027</td><td>Sanremo + Riviera ligure</td><td>×3 – ×5 (entro 10 km)</td></tr>
          <tr><td>Vasco Rossi tour stadi</td><td>Giugno 2026</td><td>Milano, Torino, Bari, Roma, Napoli</td><td>×1,8 – ×3</td></tr>
          <tr><td>Coldplay Music of the Spheres</td><td>Luglio 2026</td><td>Napoli, Milano (San Siro)</td><td>×2 – ×3</td></tr>
          <tr><td>Måneskin tour mondiale</td><td>Settembre 2026</td><td>Milano, Roma</td><td>×1,7 – ×2,5</td></tr>
          <tr><td>Heineken Jammin'</td><td>Giugno-Luglio</td><td>Imola/Verona</td><td>×1,8 – ×2,5</td></tr>
          <tr><td>Lucca Comics &amp; Games</td><td>Ottobre/Nov 2026</td><td>Lucca centro storico</td><td>×3 – ×5</td></tr>
          <tr><td>Umbria Jazz</td><td>Luglio 2026</td><td>Perugia centro</td><td>×1,6 – ×2,2</td></tr>
        </tbody>
      </table>

      <h3>Sport motoristico</h3>
      <table>
        <thead>
          <tr><th>Evento</th><th>Quando</th><th>Dove</th><th>Rincaro tipico</th></tr>
        </thead>
        <tbody>
          <tr><td>F1 GP Emilia-Romagna</td><td>Maggio 2026/27</td><td>Imola + Bologna + Faenza</td><td>×2 – ×3 (entro 30 km)</td></tr>
          <tr><td>F1 GP d'Italia</td><td>Settembre 2026/27</td><td>Monza + Milano nord</td><td>×2 – ×3,5</td></tr>
          <tr><td>MotoGP Mugello</td><td>Maggio/Giu 2026</td><td>Scarperia (FI) + Firenze</td><td>×2 – ×2,5</td></tr>
          <tr><td>MotoGP Misano</td><td>Settembre 2026</td><td>Misano + Riviera romagnola</td><td>×1,8 – ×2,4</td></tr>
          <tr><td>Mille Miglia</td><td>Giugno 2026/27</td><td>Brescia → Roma → Brescia</td><td>×1,5 – ×2,2</td></tr>
          <tr><td>Targa Florio</td><td>Maggio 2026</td><td>Palermo + Cefalù</td><td>×1,5 – ×2</td></tr>
        </tbody>
      </table>

      <h3>Fiere e B2B</h3>
      <table>
        <thead>
          <tr><th>Evento</th><th>Quando</th><th>Dove</th><th>Rincaro tipico</th></tr>
        </thead>
        <tbody>
          <tr><td>Salone del Mobile Milano</td><td>Apr 2026/27</td><td>Milano + Brianza</td><td>×2,5 – ×4</td></tr>
          <tr><td>Pitti Uomo Firenze</td><td>Gen, Giu 2026/27</td><td>Firenze centro</td><td>×1,5 – ×2,5</td></tr>
          <tr><td>Vinitaly Verona</td><td>Aprile 2026/27</td><td>Verona + Lago di Garda</td><td>×2 – ×3</td></tr>
          <tr><td>EICMA</td><td>Novembre 2026/27</td><td>Milano + Rho fiera</td><td>×2 – ×2,8</td></tr>
          <tr><td>Cibus Parma</td><td>Maggio 2026</td><td>Parma + Reggio Emilia</td><td>×1,8 – ×2,5</td></tr>
          <tr><td>Maker Faire Roma</td><td>Ottobre 2026/27</td><td>Roma</td><td>×1,3 – ×1,7</td></tr>
        </tbody>
      </table>

      <h3>Eventi culturali e religiosi</h3>
      <table>
        <thead>
          <tr><th>Evento</th><th>Quando</th><th>Dove</th><th>Rincaro tipico</th></tr>
        </thead>
        <tbody>
          <tr><td>Carnevale di Venezia</td><td>Feb 2026/27</td><td>Venezia + entroterra</td><td>×2 – ×3</td></tr>
          <tr><td>Settimana Santa Roma</td><td>Aprile (Pasqua)</td><td>Roma centro</td><td>×2 – ×3,5</td></tr>
          <tr><td>Biennale di Venezia (Arte)</td><td>Apr-Nov 2026</td><td>Venezia</td><td>×1,4 – ×1,8 (media)</td></tr>
          <tr><td>Calcio Storico Fiorentino</td><td>Giugno 2026</td><td>Firenze</td><td>×1,8 – ×2,3</td></tr>
          <tr><td>Palio di Siena</td><td>2 luglio, 16 ago</td><td>Siena</td><td>×3 – ×5</td></tr>
          <tr><td>Notte della Taranta</td><td>Agosto 2026</td><td>Salento (Melpignano)</td><td>×1,8 – ×2,5</td></tr>
        </tbody>
      </table>

      <h3>Sport e mega-eventi 2027</h3>
      <table>
        <thead>
          <tr><th>Evento</th><th>Quando</th><th>Dove</th><th>Rincaro tipico</th></tr>
        </thead>
        <tbody>
          <tr><td>America's Cup Napoli</td><td>Mag-Ott 2027</td><td>Napoli + Costiera</td><td>×2 – ×4</td></tr>
          <tr><td>Olimpiadi Invernali Milano-Cortina</td><td>Feb 2026</td><td>Milano, Bormio, Livigno, Cortina, Anterselva</td><td>×3 – ×6</td></tr>
          <tr><td>Paralimpiadi Milano-Cortina</td><td>Mar 2026</td><td>Stessa area Olimpiadi</td><td>×1,5 – ×2,5</td></tr>
          <tr><td>Internazionali Tennis Roma</td><td>Maggio 2026/27</td><td>Roma (Foro Italico)</td><td>×1,5 – ×2</td></tr>
        </tbody>
      </table>

      <div className="callout callout-info">
        Milano-Cortina è il <strong>singolo evento più impattante del decennio</strong> per l'arco alpino: per chi ha immobili nelle località ospitanti (Bormio, Livigno, Anterselva, San Sicario, Cortina) i prezzi sono già esauriti a 12-18 mesi di distanza, con rincari medi del 300-500%.
      </div>

      <h2>Strategia: come adeguare i prezzi evento per evento</h2>

      <h3>Fase 1 — Pre-annuncio (T-180 giorni)</h3>
      <p>
        Appena conosci la data ufficiale dell'evento, blocca il calendario al prezzo <strong>+50%</strong> sul base price. Test cautelativo: non vuoi spaventare i first-mover ma nemmeno regalare le notti.
      </p>

      <h3>Fase 2 — Early bird (T-180 a T-90)</h3>
      <p>
        Se la prima notte si vende entro 7-10 giorni dal pubblicazione, è il segnale che la domanda è alta: <strong>alza progressivamente</strong> del 15-25% sui giorni adiacenti ancora liberi. Se NON si vende, vuol dire che il base price era già alto: ferma l'aumento.
      </p>

      <h3>Fase 3 — Standard booking window (T-90 a T-30)</h3>
      <p>
        È la finestra in cui prenota la massa media. Mantieni stabile o alza progressivamente del 10-20% per scarsità. Vendi tipicamente il 50-70% dell'inventory in questa fase.
      </p>

      <h3>Fase 4 — Late booking (T-30 a T-7)</h3>
      <p>
        Per eventi di forte domanda inelastica (Sanremo, F1, Salone Mobile) <strong>continua a salire</strong>. La pena di non andare all'evento per i ritardatari supera l'extra costo. Per eventi più tiepidi: stabilizza o scendi leggermente.
      </p>

      <h3>Fase 5 — Last minute (T-7 a T-0)</h3>
      <p>
        Se sei sotto il 70% di occupazione: applica sconti tattici 10-20%. Se sei sopra il 90%: massimizza la coda finale con piccoli aumenti residuali (+5%/giorno).
      </p>

      <h2>Errori da evitare</h2>
      <ul>
        <li><strong>Non sapere quando è l'evento</strong>: il principale. Spesso le date escono 12-18 mesi prima — gli host distratti se ne accorgono a 60 giorni e perdono il treno.</li>
        <li><strong>Stesso rincaro su tutto l'evento</strong>: un concerto è un singolo giorno, una fiera è 5 giorni con domanda decrescente. Adatta il moltiplicatore giorno per giorno.</li>
        <li><strong>Cancellation policy troppo aperta</strong>: nei periodi evento usa "non rimborsabile" o "rimborso parziale" 60 giorni prima — la domanda accetta condizioni più strette.</li>
        <li><strong>Minimum stay troppo aggressivo</strong>: 3 notti minimum su un evento di 5 giorni rischi di non vendere le 2 notti di coda. Meglio 2 minimum, prezzo alto.</li>
        <li><strong>Non aggiornare le foto</strong>: per gli eventi business, foto con scrivania, internet veloce, ferro da stiro contano. Per eventi famiglia/leisure, foto del balcone e dei letti.</li>
      </ul>

      <h2>Come Locazione Turistica ti aiuta sugli eventi</h2>
      <ul>
        <li><strong>419 eventi 2026/2027</strong> già caricati nel calendario dell'app.</li>
        <li><strong>Alert prezzi</strong> a 90, 60 e 30 giorni prima dell'evento.</li>
        <li><strong>Suggerimento moltiplicatore</strong> basato sulla distanza dell'immobile dall'evento.</li>
        <li><strong>Mappa eventi</strong> per provincia: scopri eventi che non conoscevi e prima della concorrenza.</li>
      </ul>

      <blockquote>
        Gli eventi non sono picchi imprevisti — sono opportunità prevedibili. Chi le conosce in anticipo le monetizza; chi le scopre da Google Search il giorno dopo, paga la cena al competitor.
      </blockquote>
    </GuideLayout>
  );
}

const howTo = {
  name: 'Come ottimizzare i prezzi degli affitti brevi sugli eventi locali',
  steps: [
    { name: 'Mappa gli eventi della zona', text: 'Identifica tutti gli eventi (concerti, fiere, sport, cultura) nel raggio di 30 km nei prossimi 12 mesi. Locazione Turistica fornisce 419 eventi italiani 2026/2027 pre-caricati.' },
    { name: 'Blocca i periodi 180 giorni prima', text: 'Appena conosci la data ufficiale, blocca il calendario al prezzo +50% per evitare prenotazioni "regalate" prima di valutare la domanda reale.' },
    { name: 'Test early bird', text: 'Tra T-180 e T-90 dall\'evento alza progressivamente del 15-25% se le prime notti si vendono in pochi giorni. Se non si vendono, ferma l\'aumento.' },
    { name: 'Adatta giorno per giorno', text: 'Modula il moltiplicatore singolo per giorno: il sabato di un concerto vale di più del giovedì di una fiera. La curva non è piatta.' },
    { name: 'Cancellation policy più rigida', text: 'Nei periodi evento switch a "non rimborsabile" o "rimborso parziale 60gg prima". La domanda inelastica accetta condizioni più strette.' },
    { name: 'Last minute strategy', text: 'A T-7 dall\'evento, se sotto il 70% di occupazione applica sconti 10-20%. Se sopra il 90%, continua a salire di un 5% al giorno.' },
  ],
};

const faqs = [
  { q: 'Quanto prima dell\'evento alzare i prezzi?', a: 'Appena la data ufficiale è pubblica, idealmente 180 giorni prima. I fan/professionisti più organizzati prenotano subito dopo l\'annuncio. Se aspetti oltre 90 giorni rischi di aver già perso l\'early bird.' },
  { q: 'Qual è il rincaro tipico per il Festival di Sanremo?', a: 'Entro 10 km dal centro di Sanremo, per le 4 notti del Festival, i prezzi salgono da ×3 a ×5 rispetto al base price. Negli ultimi 30 giorni, se l\'occupazione locale è già al 95%, si può salire ulteriormente del 10-20% senza perdere prenotazioni.' },
  { q: 'Le Olimpiadi Milano-Cortina 2026 sono già "scariche" per chi vuole prenotare?', a: 'Quasi sì. Le strutture nelle località ospitanti (Bormio, Livigno, Anterselva, Cortina, Milano) sono in larga parte già prenotate a 12-18 mesi di distanza, con rincari medi del 300-500% sul base price. Chi ha ancora notti libere può alzare ulteriormente.' },
  { q: 'Per un evento posso usare cancellation policy non rimborsabile?', a: 'Sì ed è consigliato. Sui periodi evento la domanda inelastica accetta condizioni più strette in cambio di prezzo (anche se di norma "non rimborsabile" costa di meno, in evento è il contrario: il guest cerca la sicurezza di non essere senza alloggio).' },
  { q: 'Su Booking come imposto prezzi diversi per gli eventi?', a: 'Booking permette di creare "fence price" per periodi specifici dall\'extranet, sezione "Tariffe e disponibilità" → "Periodi promozionali" (al contrario, qui si "frenano" sconti) o usando il "Boost on dates". Per pricing dinamico complesso meglio integrarsi con un channel manager (Smoobu, Lodgify, Beds24).' },
  { q: 'Per il Salone del Mobile a Milano vale la pena affittare anche in Brianza?', a: 'Assolutamente sì. Le aree di Brianza (Monza, Lissone, Seregno) entro 30 km di metropolitana/regionale registrano rincari ×2 - ×3 perché i partecipanti cercano alternativa più economica e parcheggio gratuito. Stesso ragionamento per F1 Imola (host a Faenza, Forlì, Bologna est) e F1 Monza (host a Como, Lecco, Bergamo).' },
  { q: 'Quali sono gli eventi sportivi più impattanti per i prezzi?', a: 'In ordine: Olimpiadi Milano-Cortina 2026 (×3-6), America\'s Cup Napoli 2027 (×2-4), F1 Imola e Monza (×2-3), MotoGP Mugello e Misano (×1,8-2,5), Mille Miglia (×1,5-2,2), Targa Florio (×1,5-2). I motorsport tendono a impattare le 3 notti centrali; i grandi giochi olimpici impattano 4 settimane consecutive.' },
];
